import React from 'react';
import Modal from 'react-modal';
import { CloseIcon } from '@util/svgicon';

const EmailValidationModal = ({ isOpen, onClose }) => {
    return (
        <Modal
            isOpen={isOpen}
            ariaHideApp={false}
            className="mymodal"
            onRequestClose={onClose}
        >
            <div className="overflow-y-auto max-h-[540px] h-full flex w-[520px] p-[16px] flex-col gap-[16px] rounded-[32px] bg-[#F1F1F1] [box-shadow:0px_4px_16px_0px_rgba(0,_0,_0,_0.15)]">
                <div className="grid grid-cols-[95%_5%] px-[16px] py-[6px] rounded-[16px] text-center">
                    <p className='text-[#FF0000] text-center text-[28px] not-italic font-bold leading-[normal] tracking-[-1.12px]'>Missing Email Address</p>
                    <button className='flex justify-center items-center' onClick={onClose}>
                        <CloseIcon />
                    </button>
                </div>
                <div className='flex p-[16px] flex-col items-center gap-[24px] rounded-[16px] bg-[#FFF]'>
                    <div className='flex flex-col items-center gap-[8px]'>
                        <p className='text-[#737373] text-center text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px] max-w-[400px]'>
                            We couldn't find an email address on your Discord account. Please update your Discord profile with a valid email to proceed.
                        </p>
                    </div>
                    <div className='flex flex-col items-center gap-[16px] w-full'>
                        <button 
                            className="bg-[#5865F2] text-white p-4 rounded-xl w-full max-w-[300px] flex items-center justify-center gap-2 hover:bg-[#4752C4] transition-colors"
                            onClick={() => window.open('https://discord.com/settings/account')}
                        >
                            Open Discord Settings
                        </button>
                        <p className='text-[#737373] text-center text-[14px] not-italic font-medium leading-[20px] tracking-[-0.28px]'>
                            After adding your email, return here to continue
                        </p>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default EmailValidationModal; 